import { Routes } from '@angular/router'
import { loggedInMatch, loggedOutMatch } from '@common'

export const routes: Routes = [
  {
    path: '',
    canMatch: [loggedOutMatch],
    loadChildren: () => import('./presentation/features/auth/auth.routes').then((m) => m.AUTH_ROUTES),
  },
  {
    path: '',
    canMatch: [loggedInMatch],
    loadChildren: () => import('./presentation/features/portal/portal.routes').then((m) => m.PORTAL_ROUTES),
  },
  {
    path: '**',
    redirectTo: '',
  },
]
